import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { TabbedViewComponent } from './tabbed-view.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [CommonModule, RouterModule, NgbNavModule],
  declarations: [TabbedViewComponent],
  exports: [TabbedViewComponent]
})
export class TabbedViewModule {}
